import { Routes, Route, Navigate } from "react-router";
import ContactsPage from "./contacts/index";
import CompaniesPage from "./companies/index";
import DealsPage from "./deals/index";
import TasksPage from "./tasks/index";
import CrmTodayPage from "./today/index";
import DuplicatesPage from "./duplicates/index";
import RiskRadarPage from "./risk-radar";
import AwaySummaryPage from "./away-summary";
import ForecastPage from "./forecast/index";
import PlaybookPage from "./playbook/index";
import PolicyPage from "./policy/index";
import ReferralsPage from "./referrals/index";
import SegmentsPage from "./segments/index";
import TeamPerformancePage from "./team-performance/index";
import { AttributionAnalyticsPage } from "../analytics/index";

export default function CrmPage() {
  return (
    <Routes>
      <Route index element={<Navigate to="today" replace />} />
      <Route path="today" element={<CrmTodayPage />} />
      <Route path="contacts" element={<ContactsPage />} />
      <Route path="contacts/:contactId" element={<ContactsPage />} />
      <Route path="companies" element={<CompaniesPage />} />
      <Route path="companies/:companyId" element={<CompaniesPage />} />
      <Route path="deals" element={<DealsPage />} />
      <Route path="deals/:dealId" element={<DealsPage />} />
      <Route path="tasks" element={<TasksPage />} />
      <Route path="tasks/:taskId" element={<TasksPage />} />
      <Route path="duplicates" element={<DuplicatesPage />} />
      <Route path="forecast" element={<ForecastPage />} />
      <Route path="segments" element={<SegmentsPage />} />
      <Route path="attribution" element={<AttributionAnalyticsPage />} />
      <Route path="referrals" element={<ReferralsPage />} />
      <Route path="team-performance" element={<TeamPerformancePage />} />
      <Route path="playbook" element={<PlaybookPage />} />
      <Route path="policy" element={<PolicyPage />} />
      <Route path="away-summary" element={<AwaySummaryPage />} />
      <Route path="risk-radar" element={<RiskRadarPage />} />
    </Routes>
  );
}
